import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { MethodSection } from '../components/MethodSection';
import { OfferSection } from '../components/OfferSection';
import { AudienceSection } from '../components/AudienceSection';
import { StepsSection } from '../components/StepsSection';
import { ProofSection } from '../components/ProofSection';
import { FaqSection } from '../components/FaqSection';
import { PriceBlock } from '../components/PriceBlock';
import { SalesFooter } from '../components/SalesFooter';
export function SalesPage() {
  return <main className="min-h-screen w-full bg-brand-cream font-body selection:bg-brand-gold selection:text-brand-navy" data-id="element-200">
      <HeroSection data-id="element-201" />
      <PainSection data-id="element-202" />
      <MethodSection data-id="element-203" />
      <OfferSection data-id="element-204" />
      <AudienceSection data-id="element-205" />
      <StepsSection data-id="element-206" />
      <ProofSection data-id="element-207" />
      <FaqSection data-id="element-208" />
      <PriceBlock data-id="element-209" />
      <SalesFooter data-id="element-210" />
    </main>;
}